"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const detect_utils_1 = require("@/common/detect_utils");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const visible = (0, detect_utils_1.useVisibilityChange)({ useOnce: true });
    const targetParamRef = (0, react_1.useRef)((0, functions_1.getSearchParam)('target'));
    (0, react_1.useEffect)(() => {
        if (visible && targetParamRef.current === 'refund') {
            (0, functions_1.scrollIntoCenterView)('room_view_refund');
        }
    }, [visible]);
    const refundRef = (0, react_1.useRef)(null);
    const refundPolicy = (0, react_redux_1.useSelector)((state) => state.roomData.refund_policy);
    // ? isPreview for bottomHeight difference
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(RefundWrapper, Object.assign({ ref: refundRef, id: "room_view_refund" }, { children: [(0, jsx_runtime_1.jsxs)("h1", { children: [(0, jsx_runtime_1.jsx)(svgs_1.EditIconOutlinedSvg, {}), t('교환/환불 안내')] }), (0, jsx_runtime_1.jsxs)("h2", { children: [(0, jsx_runtime_1.jsx)(svgs_1.WarningCircleRedSvg, { css: { width: '14px', height: '14px' } }), `${t('환불/교환 문의는 작가님께 해주세요')}:)`] }), (0, html_react_parser_1.default)((0, string_utils_1.newLineCharsToBr)(refundPolicy)), (0, jsx_runtime_1.jsx)(components_1.ShowMoreButton, { elementRef: refundRef, dependency: refundPolicy, bottomElementId: isPreview ? '' : 'cart_order_div' })] })));
}
exports.default = default_1;
const RefundWrapper = styled_1.default.div `
  padding: 20px;
  margin-bottom: 10px;
  background-color: white;
  font-size: 15px;
  word-break: break-all;
  overflow: hidden;
  line-height: 24px;
  h1 {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: 15px;
    font-weight: 600;
    svg {
      margin: 0 4px 0 -4px;
    }
  }
  h2 {
    display: flex;
    align-items: center;
    column-gap: 6px;
    width: fit-content;
    padding: 4px;
    border-radius: 4px;
    margin-bottom: 14px;
    background-color: rgba(238, 136, 68, 0.1);
    color: #eb5757;
    line-height: 18px;
    font-size: 15px;
    font-weight: bold;
  }
  p {
    margin-bottom: 0;
    line-height: 24px;
  }
`;
